import axios from '@dap/shared-utils/http.js';

export default {
    getEventDict (params = {}) {
        return axios.get('/coach/api/event/dim_event_type', { params });
    },

    getEventRecommend (params = {}) {
        return axios.post('/coach/api/event/select-event', params);
    },

    getManagementList (params = {}) {
        return axios.get('/dapper/api/event/select-event/list', { params });
    },

    postEvent (params = {}) {
        return axios.post('/coach/api/event/event', params);
    },

    getCheckName (params = {}) {
        return axios.get('/coach/api/event/checkout-event', { params });
    },

    getEventWarnDict () {
        return axios.get('/coach/api/event/early_warn');
    },

    getGeneralData (params = {}) {
        return axios.get('/coach/api/early_warn/spreader', { params });
    },

    getEventFilter (params = {}) {
        return axios.get('/coach/api/early_warn/event_type', { params });
    },

    getEventTable (params = {}) {
        return axios.get('/coach/api/early_warn/event', { params });
    },

    getRealtime5 (params = {}) {
        return axios.get('/coach/api/early_warn/runtime/rt5', { params });
    },

    getRealtime60 (params = {}) {
        return axios.get('/coach/api/early_warn/runtime/rt60', { params });
    },

    getDailyData (params = {}) {
        return axios.get('/coach/api/early_warn/divided_day', { params });
    },

    getDetail (params = {}) {
        return axios.get('/coach/api/event/edit', { params });
    },

    getAnalyseData (params = {}) {
        return axios.get('/dapper/api/event/cpe/insights', { params });
    },

    getAnalyseCruxData (params = {}) {
        return axios.get('/dapper/api/event/cpe/insights/group', { params });
    },

    getAnalyseLogData (params = {}) {
        return axios.get('/dapper/api/event/cpe/oplog', { params });
    },

    getAnalyseList (params = {}) {
        return axios.get('/dapper/api/event/cpe/events', { params });
    },

    getAnalyseGroupList (params = {}) {
        return axios.get('/dapper/api/event/cpe/groups', { params });
    },

    getAnalyseDict (params = {}) {
        return axios.get('/dapper/api/event/cpe/dict', { params });
    },

    postAddBasic (params = {}) {
        return axios.post('/coach/api/callback/basic', params);
    },

    getBackMonitorList (params = {}) {
        return axios.get('/coach/api/callback/basic', { params });
    },

    getBackMonitorLog (params = {}) {
        return axios.get('/coach/api/callback/basic/log', { params });
    },

    putBackMonitorStatus (params = {}) {
        return axios.put('/coach/api/callback/basic', params);
    },

    getBackMonitorDict (params = {}) {
        return axios.get('/coach/api/callback/basic/dict', { params });
    },
};
